<template>
  <div class="min-h-screen flex items-center justify-center bg-secondary-50 dark:bg-secondary-900 px-4">
    <div class="max-w-md w-full text-center">
      <div class="text-9xl font-bold text-danger-600 dark:text-danger-400">403</div>
      <h1 class="mt-4 text-3xl font-bold text-secondary-900 dark:text-white">Access Denied</h1>
      <p class="mt-2 text-secondary-600 dark:text-secondary-400">
        You don't have permission to access this resource.
      </p>
      <p class="mt-2 text-sm text-secondary-500 dark:text-secondary-500">
        If you believe this is an error, please contact your administrator.
      </p>
      <div class="mt-8">
        <Link
          href="/"
          class="inline-flex items-center justify-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium"
        >
          <HomeIcon class="h-5 w-5 mr-2" />
          Go Home
        </Link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3';
import { HomeIcon } from '@heroicons/vue/24/outline';
</script>
